(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["franken-aufmacher"] && !Shopify.designMode) return;
  try {
    
  class FrankenAufmacher extends HTMLElement {
    connectedCallback() {
      this.bilder = Array.from(this.querySelectorAll('[data-bild]'));
      this.striche = Array.from(this.querySelectorAll('[data-zu]'));
      this.index = 0;
      if (this.bilder.length < 2) return;

      this.striche.forEach((s) => {
        s.addEventListener('click', () => {
          this.zeige(Number(s.dataset.zu));
          this.starte();
        });
      });

      this.ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.ruhig.matches) this.starte();
    }

    disconnectedCallback() {
      clearInterval(this.uhr);
    }

    starte() {
      clearInterval(this.uhr);
      if (this.ruhig && this.ruhig.matches) return;
      const sekunden = Math.max(3, Number(this.dataset.intervall) || 6);
      this.uhr = setInterval(() => this.zeige(this.index + 1), sekunden * 1000);
    }

    zeige(ziel) {
      const i = ((ziel % this.bilder.length) + this.bilder.length) % this.bilder.length;
      this.index = i;
      this.bilder.forEach((b, n) => b.toggleAttribute('data-aktiv', n === i));
      this.striche.forEach((s, n) => s.setAttribute('aria-selected', n === i ? 'true' : 'false'));
    }
  }

  if (!customElements.get('franken-aufmacher')) {
    customElements.define('franken-aufmacher', FrankenAufmacher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franken-empfehlungen"] && !Shopify.designMode) return;
  try {
    
  class FrankenEmpf extends HTMLElement {}

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-empfehlungen]').forEach((el) => {
      const url = el.dataset.url;
      if (!url || el.querySelector('.franken-empf__raster')) return;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const frisch = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-empfehlungen]');
          if (frisch) el.innerHTML = frisch.innerHTML;
        })
        .catch(() => {});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franken-fusszeile"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-franken-cookie-einstellungen]')) return;
    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franken-kopfzeile"] && !Shopify.designMode) return;
  try {
    
  class FrankenKopf extends HTMLElement {
    connectedCallback() {
      const overlay = this.querySelector('[data-overlay]');
      const auf = this.querySelector('[data-menue-auf]');
      const zu = this.querySelector('[data-menue-zu]');
      if (!overlay || !auf) return;

      const setze = (offen) => {
        overlay.hidden = !offen;
        auf.setAttribute('aria-expanded', offen ? 'true' : 'false');
        document.documentElement.style.overflow = offen ? 'hidden' : '';
      };

      auf.addEventListener('click', () => setze(true));
      if (zu) zu.addEventListener('click', () => setze(false));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !overlay.hidden) setze(false);
      });

      // Mobil: Hauptpunkte im Overlay klappen auf, immer nur einer offen.
      overlay.querySelectorAll('[data-klapp-auf]').forEach((kopf) => {
        kopf.addEventListener('click', () => {
          const offen = kopf.getAttribute('aria-expanded') === 'true';
          overlay.querySelectorAll('[data-klapp-auf]').forEach((k) => {
            k.setAttribute('aria-expanded', 'false');
            k.nextElementSibling.hidden = true;
            k.querySelector('span').textContent = '+';
          });
          if (!offen) {
            kopf.setAttribute('aria-expanded', 'true');
            kopf.nextElementSibling.hidden = false;
            kopf.querySelector('span').textContent = '–';
          }
        });
      });

      this.megamenue();
    }

    // Desktop: Feld oeffnet beim Zeigen (mit kurzer Verzoegerung gegen Flackern)
    // und bei Tastaturfokus; schliesst beim Verlassen, bei Escape und bei Klick
    // ausserhalb. Immer nur ein Feld offen.
    megamenue() {
      const punkte = [...this.querySelectorAll('[data-mega-punkt]')];
      if (!punkte.length) return;
      let timer = null;

      const zeige = (punkt, offen) => {
        const a = punkt.querySelector(':scope > a');
        const feld = punkt.querySelector('[data-mega-feld]');
        a.setAttribute('aria-expanded', offen ? 'true' : 'false');
        feld.hidden = !offen;
        punkt.classList.toggle('franken-mega__punkt--offen', offen);
      };
      const alleZu = () => punkte.forEach((p) => zeige(p, false));

      punkte.forEach((punkt) => {
        punkt.addEventListener('mouseenter', () => {
          clearTimeout(timer);
          timer = setTimeout(() => { alleZu(); zeige(punkt, true); }, 120);
        });
        punkt.addEventListener('mouseleave', () => {
          clearTimeout(timer);
          timer = setTimeout(alleZu, 160);
        });
        punkt.addEventListener('focusin', () => { alleZu(); zeige(punkt, true); });
        punkt.addEventListener('focusout', (e) => {
          if (!punkt.contains(e.relatedTarget)) zeige(punkt, false);
        });
      });

      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') alleZu(); });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) alleZu(); });
    }
  }

  if (!customElements.get('franken-kopf')) {
    customElements.define('franken-kopf', FrankenKopf);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franken-produktbereich"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const leiste = document.querySelector('[data-leiste]');
    const knopf = document.querySelector('.franken-kauf__knopf');
    // Lieferstatus beim Größenwechsel umschalten (Bestand 0 = „Zur Zeit nicht lieferbar“)
    const lieferbar = document.querySelector('[data-status-lieferbar]');
    const nicht = document.querySelector('[data-status-nicht]');
    if (lieferbar && nicht) {
      document.querySelectorAll('.franken-kauf__chips input[name="id"]').forEach((wahl) => {
        wahl.addEventListener('change', () => {
          const ja = wahl.dataset.lieferbar !== 'false';
          lieferbar.hidden = !ja;
          nicht.hidden = ja;
        });
      });
    }

    if (!leiste || !knopf) return;

    const beobachter = new IntersectionObserver(
      ([eintrag]) => { leiste.hidden = eintrag.isIntersecting; },
      { rootMargin: '0px' }
    );
    beobachter.observe(knopf);

    const leistenKnopf = leiste.querySelector('[data-leiste-knopf]');
    if (leistenKnopf) {
      leistenKnopf.addEventListener('click', () => {
        knopf.scrollIntoView({ block: 'center' });
        knopf.click();
      });
    }
  });


  class FrankenGalerie extends HTMLElement {
    connectedCallback() {
      this.buehne = this.querySelector('.franken-galerie__buehne');
      this.bilder = Array.from(this.querySelectorAll('[data-bild]'));
      this.minis = Array.from(this.querySelectorAll('[data-zu]'));
      this.punkte = Array.from(this.querySelectorAll('[data-punkt]'));
      this.ebene = this.querySelector('[data-ebene]');
      this.inner = this.querySelector('[data-ebene-inner]');
      this.index = 0;
      if (!this.buehne) return;

      this.minis.forEach((m) => {
        m.addEventListener('click', () => this.zeige(Number(m.dataset.zu)));
      });

      this.buehne.addEventListener('click', () => {
        if (window.matchMedia('(width < 750px)').matches) return;
        this.oeffne();
      });

      this.buehne.addEventListener('scroll', () => {
        const breite = this.buehne.clientWidth;
        if (!breite) return;
        const i = Math.round(this.buehne.scrollLeft / breite);
        if (i !== this.index) this.markiere(i);
      });

      if (this.ebene) {
        const zu = this.querySelector('[data-schliessen]');
        if (zu) zu.addEventListener('click', () => this.ebene.close());
        this.ebene.addEventListener('click', (e) => {
          if (e.target === this.ebene || e.target === this.inner) this.ebene.close();
        });
      }
    }

    zeige(i) {
      this.markiere(i);
      this.bilder.forEach((b, n) => b.toggleAttribute('data-aktiv', n === i));
    }

    markiere(i) {
      this.index = i;
      this.minis.forEach((m, n) => m.setAttribute('aria-selected', n === i ? 'true' : 'false'));
      this.punkte.forEach((p, n) => p.toggleAttribute('data-aktiv', n === i));
    }

    oeffne() {
      if (!this.ebene || !this.inner) return;
      const quelle = this.bilder[this.index] ? this.bilder[this.index].querySelector('img') : null;
      if (!quelle) return;
      this.inner.replaceChildren();
      const gross = quelle.cloneNode(true);
      // `sizes` des Buehnenbildes ist layoutabhaengig ("(max-width: 749px) 100vw,
      // 640px"). Uebernommen wuerde in der Lupe auf schmalen Schirmen eine kleine
      // Variante geladen — auf dem Tablet kam so ein 187-px-Bild statt des
      // vorhandenen grossen. Fuer die Lupe immer den groessten Kandidaten.
      gross.sizes = '100vw';
      gross.removeAttribute('class');
      gross.loading = 'eager';
      // Endgroesse aus drei Grenzen: hoechstens doppelte Aufloesung (darueber wird
      // das Bild unscharf, die Bestandsfotos sind nur rund 390 px breit), die
      // Buehnenbreite und das Fenster. Gerechnet wird hier statt in CSS, weil das
      // Seitenverhaeltnis erhalten bleiben muss: eine feste Breite plus
      // `max-height` liefe auf ein letterboxendes `object-fit` hinaus, und die
      // weisse Karte waere dann breiter als das Bild.
      const begrenzen = () => {
        const bw = gross.naturalWidth;
        const bh = gross.naturalHeight;
        if (!bw || !bh) return;
        const buehne = parseFloat(
          getComputedStyle(this).getPropertyValue('--galerie-breite')
        ) || 550;
        const maxBreite = Math.min(bw * 2, buehne * 2, window.innerWidth * 0.88);
        const maxHoehe = window.innerHeight * 0.80;
        const breite = Math.min(maxBreite, maxHoehe * (bw / bh));
        gross.style.width = Math.round(breite) + 'px';
        gross.style.height = 'auto';
      };
      if (gross.complete) begrenzen();
      else gross.addEventListener('load', begrenzen, { once: true });
      this.inner.appendChild(gross);
      this.ebene.showModal();
      // Nach dem Drehen oder Groesseaendern neu rechnen, solange die Lupe offen ist.
      const neuRechnen = () => {
        if (this.ebene.open) begrenzen();
        else window.removeEventListener('resize', neuRechnen);
      };
      window.addEventListener('resize', neuRechnen);
    }
  }

  if (!customElements.get('franken-galerie')) {
    customElements.define('franken-galerie', FrankenGalerie);
  }


  // Aufklapper: jeder Abschnitt fuer sich, mehrere duerfen offen stehen.
  document.addEventListener('click', (e) => {
    const kopf = e.target.closest('.franken-klapp__kopf');
    if (!kopf) return;
    const feld = kopf.nextElementSibling;
    if (!feld) return;
    const offen = kopf.getAttribute('aria-expanded') === 'true';
    kopf.setAttribute('aria-expanded', offen ? 'false' : 'true');
    feld.hidden = offen;
    const zeichen = kopf.querySelector('.franken-klapp__zeichen');
    if (zeichen) zeichen.textContent = offen ? '+' : '–';
  });

  document.addEventListener('click', (e) => {
    const knopf = e.target.closest('[data-menge]');
    if (!knopf) return;
    const feld = knopf.parentElement.querySelector('input[name="quantity"]');
    if (!feld) return;
    const jetzt = parseInt(feld.value, 10) || 1;
    feld.value = knopf.dataset.menge === '+' ? jetzt + 1 : Math.max(1, jetzt - 1);
    feld.dispatchEvent(new Event('change', { bubbles: true }));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franken-zuletzt"] && !Shopify.designMode) return;
  try {
    
  class FrankenZuletzt extends HTMLElement {
    connectedCallback() {
      this.ziel = this.querySelector('[data-ziel]');
      this.aktuell = this.dataset.aktuell;
      this.anzahl = Number(this.dataset.anzahl) || 3;
      if (!this.ziel) return;

      let liste = [];
      try {
        liste = JSON.parse(localStorage.getItem('franken:zuletzt') || '[]');
      } catch (e) {
        liste = [];
      }

      const zeigen = liste.filter((h) => h !== this.aktuell).slice(0, this.anzahl);

      if (this.aktuell) {
        const neu = [this.aktuell].concat(liste.filter((h) => h !== this.aktuell)).slice(0, 12);
        try {
          localStorage.setItem('franken:zuletzt', JSON.stringify(neu));
        } catch (e) {
          /* privates Fenster oder Speicher gesperrt — dann eben ohne */
        }
      }

      if (!zeigen.length) return;

      Promise.all(
        zeigen.map((h) =>
          fetch('/products/' + h + '.js')
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      ).then((produkte) => {
        const gute = produkte.filter(Boolean);
        if (!gute.length) return;
        this.ziel.innerHTML = gute
          .map((p) => {
            const bild = p.featured_image ? p.featured_image + '&width=600' : '';
            const preis = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
            return (
              '<a class="franken-zuletzt__kachel" href="/products/' + p.handle + '">' +
              (bild ? '<img class="franken-zuletzt__bild" src="' + bild + '" alt="" loading="lazy">' : '<span class="franken-zuletzt__bild"></span>') +
              '<p class="franken-zuletzt__name">' + p.title + '</p>' +
              '<p class="franken-zuletzt__preis">' + preis + '</p>' +
              '</a>'
            );
          })
          .join('');
        this.hidden = false;
      });
    }
  }

  if (!customElements.get('franken-zuletzt')) {
    customElements.define('franken-zuletzt', FrankenZuletzt);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
